import React, { useEffect } from "react";
import { Grid, Typography, makeStyles, Button, Paper } from '@material-ui/core';
import { Controller, useFieldArray } from 'react-hook-form';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Input from '../../common/input';
import Searcher from '../../skills/searcher';
import Skill from '../../skills/skill';

const useStyles = makeStyles({
  root: {
    width: '100%',
    padding: '1.5625rem 1.25rem',
  },
  title: {
    lineHeight: '1.75rem',
    fontWeight: 'bold',
    fontSize: '1.5rem',
    marginBottom: '1.8125rem',
  },
  container: {
    minHeight: ({ edit }) => (edit ? '14.375rem' : 'auto'),
    padding: '0.8125rem 1.25rem',
    marginBottom: '1.25rem',
  },
  searcher: {
    width: '20rem',
    marginBottom: '1.875rem',
  },
  skills: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '.625rem',
  },
});

const ProjectArray = ({ nestIndex: index, control, errors, setValue, getValues }) => {
  const classes = useStyles();
  const { fields, remove, append } = useFieldArray({
    control,
    name: `positions[${index}].projects`
  });

  useEffect(() => { append({ name: '' , description: '', skills: [] }) }, []);

  return (
    <Grid container className={classes.root} direction="column">
      {fields.map((project, projectIdx) => {
        const fieldName = `positions[${index}].projects[${projectIdx}]`;
        const handleSelect = (skill) => {
          const newSkills = [...getValues(`${fieldName}.skills`), skill];
          setValue(`${fieldName}.skills`, newSkills );
        };
        const handleDelete = (skill) => {
          const skillArray = getValues(`${fieldName}.skills`)
          const newSkills = skillArray.filter(item => item.hash !== skill.hash);
          setValue(`${fieldName}.skills`, newSkills );
        }

        return (
          <Grid item key={`${project.id}`}>
            <Controller
              control={control}
              name={`${fieldName}.name`}
              defaultValue={project.name}
              render={({ onChange, onBlur, value }) => (
                <Grid container direction="column">
                  <Grid item>
                    <Typography className={classes.title} variant="button" component="h4">
                      Project
                    </Typography>
                  </Grid>
                  <Grid container item direction="row" spacing={2}>
                    <Grid item>
                      <Button variant="contained" color="primary" onClick={() => append({ name: '', description: '', skills: []})}>
                        <FontAwesomeIcon icon={faPlus} />
                      </Button>
                    </Grid>
                    <Grid item>
                      <Input
                        placeholder="Project name"
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        invalid={errors && errors.positions && errors.positions[index] && errors.positions[index].projects 
                                && errors.positions[index].projects[projectIdx] && errors.positions[index].projects[projectIdx].name}
                        message={errors && errors.positions && errors.positions[index] && errors.positions[index].projects 
                                && errors.positions[index].projects[projectIdx] && errors.positions[index].projects[projectIdx].name
                                && errors.positions[index].projects[projectIdx].name.message}
                      />
                    </Grid>
                    <Grid item>
                      <Button variant="outlined" color="primary" onClick={() => fields?.length > 1 && remove(projectIdx)}>
                        <FontAwesomeIcon icon={faTrash} />
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            />
            <Controller
              control={control}
              name={`${fieldName}.description`}
              defaultValue={project.description}
              render={({ onChange, onBlur, value }) => (
                <Grid item>
                  <Input
                    textarea={true}
                    placeholder="Project description"
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    invalid={errors && errors.positions && errors.positions[index] && errors.positions[index].projects 
                      && errors.positions[index].projects[projectIdx] && errors.positions[index].projects[projectIdx].description}
                    message={errors && errors.positions && errors.positions[index] && errors.positions[index].projects 
                      && errors.positions[index].projects[projectIdx] && errors.positions[index].projects[projectIdx].description
                      && errors.positions[index].projects[projectIdx].description.message}
                  />
                </Grid>
              )}
            />
            <Controller
              control={control}
              name={`${fieldName}.skills`}
              defaultValue={project.skills}
              render={({ onChange, onBlur, value }) => (
                <Paper className={classes.container}>
                  <Typography className={classes.title} variant="button" component="h4">
                    Tech involved
                </Typography>
                  <div className={classes.searcher}>
                    <Searcher onSelect={(skill) => handleSelect(skill)} />
                  </div>
                  <div className={classes.skills}>
                    {value.map((skill, skillIdx) => (
                      <div key={`positions[${index}].projects[${projectIdx}]skill-${skillIdx}`} className={classes.skill}>
                        <Skill {...skill} onDelete={() => handleDelete(skill)} />
                      </div>
                    ))}
                  </div>
                </Paper>
              )}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ProjectArray;